import { FormStyle, getLocaleDayPeriods, TranslationWidth } from '@angular/common';
      import * as momentImported from 'moment';
      import { TimeMaskHelper } from './time-mask-helper';
      
      const moment = momentImported;
      
      export class TimeLocaleHelper {
      
          // NOTE: we take day period (AM, PM) from Angular locale 
          // Moment locale may not have the same day period
          // E.g, 'de' Angular locale has ['vm.', 'nm.'], ['vorm.', 'nachm.'] day periods,
          // while Moment has ['AM', 'PM']
          // OR 'zh' Angular locale has ['上午', '下午'] day periods,
          // while Moment has 凌晨|早上|上午|中午|下午|晚上 (6 meridiems)
          static setCustomMomentLocale(locale: string) {
      
              const customTimepickerMomentLocaleName = `waf-time-input/${locale}`;
      
              // set custom locale only once
              if (moment.locales()[customTimepickerMomentLocaleName] != null) {
                  return customTimepickerMomentLocaleName;
              }
      
              var dayPeriods = getLocaleDayPeriods(locale, FormStyle.Standalone, TranslationWidth.Narrow);
      
              var morningDayPeriodString = dayPeriods[0]; // 'AM', vorm.'
              var afternoonDayPeriodString = dayPeriods[1]; // 'PM', 'nachm.'
      
              const globalMomentLocale = moment.locale();
      
              // create a separate new Moment locale for the waf-time-input
              // otherwise, if we override regular locale (say, 'de'), the changes will be visible outside the control
              moment.defineLocale(customTimepickerMomentLocaleName,
                  {
                      parentLocale: locale, // 'de'
                      meridiemParse: TimeMaskHelper.getCaseInsensitiveRegexImpl([morningDayPeriodString, afternoonDayPeriodString], '*'), // /[vorm\\.nach]*/i
                      meridiemHour: null, // reset for 'zh' and other locales that have > 2 day periods in moment.js (we use Angular's locales that have 2 day periods)
                      meridiem: function (hours, minutes, isLower) {
                          if (hours > 11) {
                              return isLower ? afternoonDayPeriodString.toLowerCase() : afternoonDayPeriodString.toUpperCase();
                          } else {
                              return isLower ? morningDayPeriodString.toLowerCase() : morningDayPeriodString.toUpperCase();
                          }
                      },
                      isPM: function localeIsPM(meridiem) {
                          if (meridiem) {
                              meridiem = meridiem.trimRight(); // e.g., 'A. M. ' in 'es' locale if format = 'A hh:mm'
                          } else {
                              meridiem = '';
                          }
      
                          const matchesMorningDayPeriodString = morningDayPeriodString.toLowerCase().startsWith(meridiem.toLowerCase());
                          const matchesAfternoonDayPeriodString = afternoonDayPeriodString.toLowerCase().startsWith(meridiem.toLowerCase());
      
                          return matchesAfternoonDayPeriodString && !matchesMorningDayPeriodString;
                      }
                  });
      
      
              // moment.defineLocale() will set the Global locale to customTimepickerMomentLocaleName
              // reset Global locale back to prior to customTimepickerMomentLocaleName value
              moment.locale(globalMomentLocale);
      
              return customTimepickerMomentLocaleName;
          }
      }